<nav class="app-event-nav navbar toggle-color navbar-expand-lg navbar-dark top-header-parent bg-dark fixed-top z-index-999 h-56 "
    [ngClass]="{'bg-transparent':leftMenu,'d-none':paymentStatus}">
    <ng-container *ngIf="!streamInfo?.event_logo && !affiliateInfo?.channel_logo">
        <ng-container *ngIf="!leftMenu">
            <div class="logo pointer p-0" (click)="goToMainScreen()">
                <img [src]="clientDetails.footer_logo" class="h-31">
                <!-- <span class="h-31"><app-svg [icon]="'logo-icon'"></app-svg></span> -->
            </div>
        </ng-container>
        <ng-container *ngIf="leftMenu">
            <div class="logo pointer logo-bg" (click)="goToMainScreen()">
                <img [src]="clientDetails.header_logo" class="h-31">
            </div>
        </ng-container>
    </ng-container>
    <!-- <ng-container *ngIf="leftMenu"> -->
    <ng-container *ngIf="streamInfo?.event_logo">
        <div class="logo pointer logo-bg pt-5 pl-5 pr-5 text-center" (click)="goToMainScreen()">
            <img src="{{streamInfo?.event_logo}}" class="h-25p m-0">
            <div>
                <!-- <img class="h-20 mt-5" height="20" [src]="assets_url + 'Powered-By.svg'"> -->
                <span class="mt-1">
                    <!-- <app-svg [icon]="'powered-by-bb'"></app-svg> -->
                    <!-- <img [src]="clientDetails.header_logo" class="env-logo"> -->
                </span>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="affiliateInfo?.channel_logo && !streamInfo?.event_logo">
        <div class="logo pointer logo-bg p-5 text-center" (click)="goToMainScreen()">
            <img src="{{affiliateInfo?.channel_logo}}" class="h-25p m-0">
            <div>
                <!-- <img class="h-20 mt-5" height="20" [src]="assets_url + 'Powered-By.svg'"> -->
                <span class="h-20 mt-1">
                    <!-- <app-svg [icon]="'powered-by-bb'"></app-svg> -->
                    <!-- <img [src]="clientDetails.header_logo" class="env-logo"> -->
                </span>
            </div>
        </div>
    </ng-container>
    <!-- </ng-container> -->
    <div class="d-inline-block d-lg-none">
        <div *ngIf="leftMenu" class=" google-translate pt-1 d-inline-block" fxShow.xs="true" fxShow.sm="true" fxHide>
            <span class="btn btn-primary dropdown-toggle gt-toggle" type="button" (click)="clearSearch()"
                id="dropdownMenuButton1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">

                <span class="d-inline-block w-150p notranslate">


                    <span *ngIf="currency?.length <= 4" class="active-color v-bottom">{{ currency }}</span>
                    <span *ngIf="currency?.length > 4" class="active-color v-bottom">
                        {{ currency | slice: 0:4 }}
                        {{currency?.length > 4 ? "" : ""}}
                    </span></span>
            </span>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <input type="text" placeholder="Search.." class="search-input" [(ngModel)]="searchCurrency">
                <i class="fa fa-search drpdwn-search text-white " aria-hidden="true"></i>
                <span *ngFor="let currency of currencyJSON | filter: searchCurrency:'currency';let i=index"
                    class="notranslate">
                    <a class="dropdown-item fs-13" [ngClass]="{'pt-45':i == 0}"
                        (click)="changeCurrency(currency.currency)">{{currency.currency}}</a></span>


                <!-- <span *ngFor="let lang of languages"  class="notranslate">
                        <a class="dropdown-item fs-13" *ngIf="lang.name"
                            (click)="changeLanguage(lang)"><input type="radio" aria-label="Radio button for following text input">{{lang.name}}</a></span> -->
            </div>
        </div>
        <span fxShow.xs="true" [hidden]="route.snapshot.queryParams.language" fxShow.sm="true" fxHide
            class="d-inline-block pt-1">
            <app-google-translate></app-google-translate>
        </span>
        <div *ngIf="!loggedIn && !userIdParam" fxShow.xs="true" fxShow.sm="true" fxHide class="fa fa-user pl-3 "
            (click)="redirectTo('signin')"></div>
        <!-- <div fxShow.xs="true" fxShow.sm="true" fxHide class="artist-pic mr-10 text-center pointer" (click)="sideMenu()"
            *ngIf="!userInfo?.is_guest && loggedIn && userInfo?.profile_pic != null && userInfo.profile_pic !=''"
            [ngStyle]="{'background-image':' url(' + userInfo?.profile_pic + ')'}"></div>
        <button fxShow.xs="true" fxShow.sm="true" fxHide class="profile-pic notranslate p-o mr-5" (click)="sideMenu()"
            *ngIf="!userInfo?.is_guest && loggedIn && (userInfo?.profile_pic == null || userInfo?.profile_pic == '')"> {{displayName
            |uppercase}}
        </button> -->
        <div class="dropdown d-inline-block ml-15"
            [ngClass]="{'t-10':userInfo?.profile_pic != null && userInfo.profile_pic !=''}" fxShow.xs="true"
            fxShow.sm="true" fxHide>
            <a id="dLabel"
                *ngIf="loggedIn && !userInfo?.is_guest && (userInfo?.profile_pic == null || userInfo?.profile_pic == '')"
                role="button" data-toggle="dropdown" class="profile-pic notranslate mr-15" data-target="#">
                <span matTooltipPosition="above" matTooltip="{{userInfo?.display_name}}"> {{displayName
                    |uppercase}}</span>
            </a>
            <a id="dLabel"
                *ngIf="loggedIn && !userInfo?.is_guest  && userInfo?.profile_pic != null && userInfo.profile_pic !=''"
                role="button" data-toggle="dropdown"
                [ngStyle]="{'background-image':' url(' + userInfo?.profile_pic + ')'}"
                class="artist-pic m-0 text-center pointer mr-15" data-target="#">
            </a>
            <ul class="dropdown-menu menu-block h-90">
                <li class="p-5" [routerLink]="'/' + channelName + '/user-dashboard/profile-settings/basic-info'">Account</li>
                <li (click)="signout()" class="p-5">Sign Out</li>
            </ul>
        </div>
    </div>
    <div class="collapse navbar-collapse align-content-end" id="navbarSupportedContent">
        <ul class="navbar-nav pointer pr-10" [ngClass]="{'logo-bg':leftMenu,'ptb-5':leftMenu}" *ngIf="!userIdParam">
            <span class="pr-10 m-auto" fxhide.xs="true" fxshow="">
                <a (click)="gotoCommunities()" class="mr-2 ml-2 pointer" routerlinkactive="active" *ngIf="loggedIn">Communities</a>
            </span>
            <div class="dropdown mr-20 marketplace d-none d-md-inline-block">
                <a class=" dropdown-toggle text-light" id="dropdownMenuButton2" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
                    Marketplace
                </a>
                <div class="dropdown-menu dropdown-menu1" aria-labelledby="dropdownMenuButton2">
                    <a class="dropdown-item" routerLink="/network-market/market"
                        routerLinkActive="bg-active">Merchandise</a>
                    <a class="dropdown-item" routerLink="/network-market/event" routerLinkActive="bg-active">Events</a>
                </div>
            </div>
            <span class="mr-2 pt-1">
                <app-google-translate></app-google-translate>
            </span>
            <li *ngIf="leftMenu">
                <div class="dropdown google-translate pt-1">
                    <div class="btn btn-primary dropdown-toggle" (click)="clearSearch()" type="button"
                        id="dropdownMenuButton1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span class="d-inline-block w-150p notranslate">
                            <span *ngIf="currency?.length <= 4" class="active-color v-bottom">{{ currency }}</span>
                            <span *ngIf="currency?.length > 4" class="active-color v-bottom">
                                {{ currency | slice: 0:4 }}
                                {{currency?.length > 4 ? "" : ""}}
                            </span></span>
                    </div>
                    <div class="dropdown-menu  p-0" aria-labelledby="dropdownMenuButton1">
                        <div class="relative"><input type="text" placeholder="Search.." class="search-input m-0"
                                [(ngModel)]="searchCurrency">
                            <i class="fa fa-search drpdwn-searchf text-white " [ngClass]="{'user-search':userInfo?.id}"
                                aria-hidden="true"></i>
                        </div>
                        <div class="overflow-d">
                            <span *ngFor="let currency of currencyJSON | filter: searchCurrency:'currency';let i=index"
                                class="notranslate">
                                <a class="dropdown-item fs-13" [ngClass]="{'':i == 0}"
                                    (click)="changeCurrency(currency.currency)">{{currency.currency}}</a></span>
                        </div>


                        <!-- <span *ngFor="let lang of languages"  class="notranslate">
                            <a class="dropdown-item fs-13" *ngIf="lang.name"
                                (click)="changeLanguage(lang)"><input type="radio" aria-label="Radio button for following text input">{{lang.name}}</a></span> -->
                    </div>
                </div>
            </li>
            <!-- <li *ngIf="!loggedIn" fxShow fxHide.xs="true" (click)="redirectTo('signup')">
                <button mat-flat-button class="flat-primary-button mt2 mr-25 ml-20" [ngClass]="{'mt-2':leftMenu}">Sign Up</button>
            </li> -->
            <li *ngIf="!loggedIn" fxShow fxHide.xs="true">
                <button mat-flat-button class="flat-primary-button mt2 tertiary-bg-button" [ngClass]="{'mt-2':leftMenu}"
                    (click)="redirectTo('signin')">Sign In / Up</button>
            </li>
            <li>
                <div class="dropdown ml-20">
                    <!-- <button fxShow fxHide.xs="true" class="profile-pic notranslate mtb-5 mr-15" (click)="sideMenu()"
                    *ngIf="loggedIn && !userInfo?.is_guest && (userInfo?.profile_pic == null || userInfo?.profile_pic == '')">
                    {{displayName |uppercase}} </button>
                <div fxShow fxHide.xs="true" class="artist-pic m-0 text-center pointer mtb-5 mr-15" (click)="sideMenu()"
                    *ngIf="loggedIn && !userInfo?.is_guest  && userInfo?.profile_pic != null && userInfo.profile_pic !=''"
                    [ngStyle]="{'background-image':' url(' + userInfo?.profile_pic + ')'}"></div> -->
                    <a id="dLabel"
                        *ngIf="loggedIn && !userInfo?.is_guest && (userInfo?.profile_pic == null || userInfo?.profile_pic == '')"
                        role="button" data-toggle="dropdown" class="profile-pic notranslate mtb-5 mr-15"
                        data-target="#">
                        <span matTooltipPosition="above" matTooltip="{{userInfo?.display_name}}"> {{displayName
                            |uppercase}}</span>
                    </a>
                    <a id="dLabel"
                        *ngIf="loggedIn && !userInfo?.is_guest  && userInfo?.profile_pic != null && userInfo.profile_pic !=''"
                        role="button" data-toggle="dropdown"
                        [ngStyle]="{'background-image':' url(' + userInfo?.profile_pic + ')'}"
                        class="artist-pic pointer mtb-5 mr-15 d-block" data-target="#">
                    </a>
                    <ul class="dropdown-menu menu-block h-90">
                        <li class="p-5" [routerLink]="'/' + channelName + '/user-dashboard/profile-settings/basic-info'">Account</li>
                        <li (click)="signout()" class="p-5">Sign Out</li>
                    </ul>
                </div>
            </li>
            <!-- <div>
                <button fxShow fxHide.xs="true" class="profile-pic notranslate mtb-5 mr-15" (click)="sideMenu()"
                    *ngIf="loggedIn && !userInfo?.is_guest && (userInfo?.profile_pic == null || userInfo?.profile_pic == '')">
                    {{displayName |uppercase}} </button>
                <div fxShow fxHide.xs="true" class="artist-pic m-0 text-center pointer mtb-5 mr-15" (click)="sideMenu()"
                    *ngIf="loggedIn && !userInfo?.is_guest  && userInfo?.profile_pic != null && userInfo.profile_pic !=''"
                    [ngStyle]="{'background-image':' url(' + userInfo?.profile_pic + ')'}"></div>

            </div> -->
        </ul>
    </div>
    <ng-container *ngIf="isNetworkNotification">

        <div class="position-ab-notification">
            <div class="row no-gutters title-cls">
                <div class="col-11">
                    <p class="fs-15 mb-0">{{message}}</p>
                </div>
                <div class="col-1 text-right pointer" (click)=closeBox()>
                    <i class="fa fa-times-circle" aria-hidden="true"></i>
                </div>
            </div>
            <div class="row no-gutters p-3">
                <div class="col-12 text-center">
                    <button class="join-nt-btn pt-5" (click)="joinUrl()">JOIN</button>
                </div>
            </div>
            <!-- <div class="bg-secondary-embed ff text-white">
                <span class="ellipsis-text pointer pt-5">{{inviteKey}}</span> <span> <button class="copy-btn pt-5"
                        id="btnCopyClip" (click)="copyToClipboard()">COPY</button>
                </span>
            </div> -->
        </div>
    </ng-container>
    <!-- <ng-container *ngIf="toggleMenu">
        <div class="menu-block pointer">
            <h6 routerLink="/user-dashboard/profile-settings/basic-info" class="menu-name">Account</h6>
            <h6 (click)="signout()" class="menu-name">Sign Out</h6>
        </div>
    </ng-container> -->
</nav>
